import React from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import { OutgoingEvents } from '../../../../../pages/call/iframe-sagas/types';
import { selectIsGlobalBarEnabled } from '../../../../features/config/selectors';
import { parentFrameCommunicator } from '../../../../features/parent-frame-communicator';
import { i18n } from '../../../../helpers/i18n';
import Button from '../../../button';
import I18N from '../../../i18n';
import Link from '../../../link';
import css from './styles.css';

export const UnsupportedMessengerPage: React.FunctionComponent = () => {
    const isGlobalBarEnabled = useSelector(selectIsGlobalBarEnabled);

    return (
        <div className={cn(css.Unsupported_container, { [css.containerWithoutHeaderAndFooter]: isGlobalBarEnabled })}>
            <span className={css.Unsupported_title}>{i18n('error-page', 'unsupported-messenger-title')}</span>
            <span className={css.Unsupported_subtitle}>
                <I18N keyset="error-page" loc="unsupported-messenger-description">
                    <Link
                        data-ref="link-help"
                        className={css.Unsupported_link}
                        view="default"
                        href="https://yandex.ru/support/yandex-360/business/messenger/ru/install/"
                        target="_blank"
                    />
                </I18N>
            </span>
            <Button
                view="brand"
                elementType="a"
                size="lg"
                onClick={() => {
                    parentFrameCommunicator.sendMessage('messenger', {
                        event: OutgoingEvents.DISCONNECTED,
                        payload: { id: 'self' },
                    });
                }}
            >
                {i18n('error-page', 'close-button-title')}
            </Button>
        </div>
    );
};
